module.exports = __webpack_public_path__ + "infocentrum22.jpg?822c9e687155731ebedad7bb327f4ac0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum22.jpg
// module id = 274
// module chunks = 0